/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import ImageAttribution from '../shared/ImageAttribution';

const AssessmentSummaryScreen = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Image" instructions="Describe an image that aligns with the content in this module." />
      <Controller 
        control={control}
        name="content.media"
        render={({ field }) => <ImageAttribution targetObj="content.media" inputDir={inputDir} errors={errors.content?.media} {...{control }} />}
      />

      <Divider className="mt-16" />

      <NumberedHeading number="2" title="Minimum Score" instructions="Enter the minimum score the learner should get." />
      <Controller
        control={control}
        name="content.min_score"
        render={({ field }) => (
          <TextField
            {...field}
            className="mt-16 mb-16"
            label="Minimum Score"
            placeholder="Minimum Score"
            error={!!errors.content?.min_score}
            helperText={errors.content?.min_score?.message}
            fullWidth
            required
            type="number"
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="3" title="TL Summary Text" instructions="Enter the results summary text in the target language." />
      <Controller
        control={control}
        name="content.tl_prefix"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.tl_prefix} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="4" title="EN Summary Text" instructions="Enter the results summary text in the target language." />
      <Controller
        control={control}
        name="content.en_prefix"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.en_prefix} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="5" title="TL Passed Suffix" instructions="Enter text in the target language for when a learner passes the assessment." />
      <Controller
        control={control}
        name="content.tl_passed"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.tl_passed} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="6" title="EN Passed Suffix" instructions="Enter text in English for when a learner passes the assessment." />
      <Controller
        control={control}
        name="content.en_passed"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.en_passed} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="7" title="TL Failed Suffix" instructions="Enter text in the target language for when a learner fails the assessment." />
      <Controller
        control={control}
        name="content.tl_failed"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.tl_failed} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="8" title="EN Failed Suffix" instructions="Enter text in English for when a learner fails the assessment." />
      <Controller
        control={control}
        name="content.en_failed"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.en_failed} />}
      />
    </div>
  );
};

export default AssessmentSummaryScreen;